'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TetheredComponent = TetheredComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = _react2['default'].PropTypes;


var leftOrRight = function leftOrRight(pos) {
    return pos === 'left' || pos === 'right';
};
var topOrBottom = function topOrBottom(pos) {
    return pos === 'top' || pos === 'bottom';
};

/**
 * Tethered Component
 *
 * A tethered component is a component that positions itself around another
 * element on the page.  Things like tooltips and dropdown menus can be tethered
 * compoents.  This component takes in an `anchor` and renders the provided
 * children around the anchor in different locations depending on the props.
 */
function TetheredComponent(props) {
    var active = props.active,
        align = props.align,
        anchor = props.anchor,
        children = props.children,
        justify = props.justify,
        position = props.position,
        theme = props.theme;


    var className = (0, _classnames2['default'])('hs-ui-tethered', { 'hs-ui-tethered--light': theme === 'light' }, { 'hs-ui-tethered--pos-bottom': position === 'bottom' }, { 'hs-ui-tethered--pos-top': position === 'top' }, { 'hs-ui-tethered--pos-bottom': position === 'bottom' }, { 'hs-ui-tethered--pos-right': position === 'right' }, { 'hs-ui-tethered--pos-left': position === 'left' }, { 'hs-ui-tethered--justify-left': topOrBottom(position) && justify === 'left' }, { 'hs-ui-tethered--justify-center': topOrBottom(position) && justify === 'center' }, { 'hs-ui-tethered--justify-right': topOrBottom(position) && justify === 'right' }, { 'hs-ui-tethered--align-top': leftOrRight(position) && align === 'top' }, { 'hs-ui-tethered--align-center': leftOrRight(position) && align === 'center' }, { 'hs-ui-tethered--align-bottom': leftOrRight(position) && align === 'bottom' });

    return _react2['default'].createElement(
        'div',
        { className: className },
        anchor,
        active && _react2['default'].createElement(
            'div',
            { className: 'hs-ui-tethered__content' },
            children
        )
    );
}

TetheredComponent.propTypes = {

    /**
     * If true, the content will be rendered
     */
    active: PropTypes.bool,

    /**
     * Aligns the content vertically.  This only takes effect when the position
     * is 'left' or 'right'.
     */
    align: PropTypes.oneOf(['top', 'center', 'bottom']),

    /**
     * Aligns the content horizontally.  This only takes effect when the
     * position is 'top' or 'bottom'.
     *
     */
    justify: PropTypes.oneOf(['left', 'center', 'right']),

    /**
     * The element to position the content around.
     */
    anchor: PropTypes.node.isRequired,

    /**
     * The position of the content around the anchor.
     */
    position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),

    /**
     * The theme of the content.  The theme defines any baseline style for the
     * content wrapper.  Right now there's just "light" but in the future this
     * here for future additions.
     */
    theme: PropTypes.oneOf(['light'])
};

TetheredComponent.defaultProps = {
    align: 'top',
    justify: 'left',
    position: 'bottom',
    theme: 'light'
};

exports['default'] = TetheredComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/tethered/tethered.jsx
 ** module id = 776
 ** module chunks = 0 1
 **/